<template>
    <span class="a-item-info-contrast item-info-contrast">
        <span class="item-info-contrast__point">
            {{ targetZone }}
        </span>
        <span class="item-info-contrast__floor">
            {{ floor }}
        </span>
    </span>
</template>

<script>
export default {
    name: 'AItemInfoContrast',
    props: {
        targetZone: {
            type: String,
            default: ''
        },
        floor: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
  @import "a-item-info-contrast";
</style>